import React from 'react';
import PropTypes from 'prop-types';
import Carousel from '@ow/ow-components/lib/components/Carousel';
import theme from '@ow/ow-components/lib/theme';
import styled from 'styled-components';
import { Picture } from 'pixboost-react';
import { apiKey, domain, breakpoints } from '../../constants/imageOptimisation';
import Media from 'react-media';

const Wrapper = styled.div`
  background-color: ${theme.colors.gallery};
  padding: 20px;
`;

const JumbotronSlide = styled.div`
  border-radius: ${theme.space.quarter};
  background-color: ${theme.colors.white};
  box-shadow: 4px 4px 10px 0 rgba(0, 0, 0, 0.08);
  overflow: hidden;
  min-height: 180px;
  margin: ${theme.space.half};
`;

const SlideTitle = styled.h6`
  text-align: left;
  padding: ${theme.space.half};
  color: ${theme.colors.primary};
  font-size: ${theme.fontSizes.standard};
  margin: 0;
`;

const StyledPicture = styled(({ ...rest }) => <Picture {...rest} />)`
  max-width: 100%;
  img {
    max-width: 100%;
  }
`;

const Jumbotron = props => {
  return (
    <Wrapper>
      <Media query={`(max-width: ${theme.screenSizes.md.max}px)`}>
        {isSmallScreen => {
          return (
            <Carousel
              itemsPerSlide={isSmallScreen ? 2 : 4}
              autoplay={false}
              showPagination={false}
              paginatedScroll={false}
              leftButton={props.renderLeftButton}
              rightButton={props.renderRightButton}
              disableTileStyles={true}
            >
              {props.items.map((slide, index) => (
                <JumbotronSlide key={`${index}-${slide.imageUrl}`}>
                  <a href={slide.link} target={slide.target}>
                    <StyledPicture
                      alt={slide.title}
                      breakpoints={{
                        lg: {
                          src: slide.imageUrl
                        },
                        md: {
                          src: slide.imageUrl
                        },
                        sm: {
                          src: slide.imageMobileUrl || slide.imageUrl
                        }
                      }}
                      config={{ domain, apiKey, breakpoints }}
                    />
                    <SlideTitle>{slide.title}</SlideTitle>
                  </a>
                </JumbotronSlide>
              ))}
            </Carousel>
          );
        }}
      </Media>
    </Wrapper>
  );
};

Jumbotron.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      imageUrl: PropTypes.string.isRequired,
      imageMobileUrl: PropTypes.string,
      link: PropTypes.string,
      target: PropTypes.string,
      title: PropTypes.string
    })
  ).isRequired,
  renderLeftButton: PropTypes.func,
  renderRightButton: PropTypes.func
};

export default Jumbotron;
